export const URL_API = process.env.NODE_ENV === 'production' ? 'https://apireferenciamaterna-d7enbddcf0d5bmaq.centralus-01.azurewebsites.net/'
: "http://localhost:5004/"
//http://localhost:21021

export const LST_TIPO_IDENTIFICACION = [
    { value: "Cédula", key: "C" },
    { value: "Pasaporte", key: "P" }
  ];

  export const LST_ORIGEN_IDENTIFICACION = [

    { value: "Redes sociales", label: "Redes sociales",disabled: false  },
    { value: "Página web ", label: "Página web",disabled: false  },
    { value: "Publicidad ", label: "Publicidad" ,disabled: false },
    { value: "Sucursal", label: "Sucursal",disabled: false  },
    { value: "Recomendación", label: "Recomendación" ,disabled: false  },
    { value: "Plaza comercial", label: "Plaza comercial" ,disabled: false  },
    { value: " Estación del metro", label: " Estación del metro" ,disabled: false  },
    { value: "Jumbo", label: "Jumbo" ,disabled: false  },
    { value: "Embarazadas Fit", label: "Embarazadas Fit" ,disabled: false  },
  
  ];


  export const LST_Provincia = [
    { value: "Azua", label: "Azua" },
    { value: "Bahoruco", label: "Bahoruco" },
    { value: "Barahona" , label: "Barahona" },
    { value: "Dajabón" , label: "Dajabón" },
    { value: "Distrito Nacional", label: "Distrito Nacional" },
    { value: "Duarte", label: "Duarte" },
    { value: "El Seibo", label: "El Seibo" },
    { value: "Elías Piña", label: "Elías Piña" },
    { value: "Espaillat" , label: "Espaillat"},
    { value: "Hato Mayor" , label: "Hato Mayor"},
    { value: "Hermanas Mirabal", label: "Hermanas Mirabal" },
    { value: "Independencia" , label: "Independencia"},
    { value: "La Altagracia" , label: "La Altagracia"},
    { value: "La Romana" , label: "La Romana "},
    { value: "La Vega" , label: "La Vega"},
    { value: "María Trinidad Sánchez", label: "María Trinidad Sánchez" },
    { value: "Monseñor Nouel", label: "Monseñor Nouel" },
    { value: "Monte Cristi" , label: "Monte Cristi"},
    { value: "Monte Plata" , label: "Monte Plata"},
    { value: "Pedernales" , label: "Pedernales"},
    { value: "Peravia" , label: "Peravia"},
    { value: "Puerto Plata" , label: "Puerto Plata"},
    { value: "Samaná" , label: "Samaná"},
    { value: "Sánchez Ramírez", label: "Sánchez Ramírez" },
    { value: "San Cristóbal", label: "San Cristóbal" },
    { value: "San José de Ocoa", label: "San José de Ocoa" },
    { value: "San Juan de la Maguana" , label: "San Juan de la Maguana"},
    { value: "San Pedro de Macorís", label: "San Pedro de Macorís" },
    { value: "Santiago", label: "Santiago" },
    { value: "Santiago Rodríguez", label: "Santiago Rodríguez" },
    { value: "Santo Domingo", label: "Santo Domingo" },
    { value: "Valverde", label: "Valverde" }
  ];

  export const LST_TIPO_FAMILIA= [
    { value: "Cónyuge", key: "9000" },
    { value: "Hijo", key: "9001" },
    { value: "Hija", key: "9013" },
    { value: "Madre", key: "9004" },
    { value: "Padre", key: "9005" },
    { value: "Hijo(a) Adoptivo", key: "9002" },
    { value: "Hijo(a) Discapacitado", key: "9003" },
    { value: "Ex-Cónyuge", key: "9006" },
    { value: "Abuela", key: "9007" },
    { value: "Abuelo", key: "9008" },
    { value: "Suegra", key: "9009" },
    { value: "Suegro", key: "9010" },
    { value: "Hijastro", key: "9011" },
    { value: "Hijastra", key: "9012" }
 
  ];
  
  export const OBJ_TIPO_IDENTIFICACION = {
    "C":{ value: "Cédula",  },
    "P": { value: "Pasaporte" }
  };
  export const LST_SEXOS = [
    { key: "M", value: "Masculino" },
    { key: "F", value: "Femenino" }
  ];

  export const OBJ_SEXOS = {
   "M":{value: "Masculino" },
    "F":{value: "Femenino" }
  }
  
  export const LST_PARENTESCOS_MENORES = [
    "HIJO/A",
    "HERMANO/A",
    "NIETO/A",
    "BIZNIETO/A",
    "TIO/A",
    "SOBRINO/A",
    "CUÑADO/A",
    "PRIMO/A",
    "AMIGO/A",
    "VECINO/A",
    "TUTOR/A",
    "ESPOSO/A",
    "CÓNYUGE",
    "PAREJA",
    "OTRO"
  ];

  export const LST_NACIONALIDADES = [
    "AFGANA",
    "ALBANES",
    "ALEMANA",
    "ANGOLANA",
    "ANTIGUANA",
    "ARGELINA",
    "ARGENTINA",
    "ARMENIO",
    "AUSTRÍACA",
    "BANGLADESÍ",
    "BARBADENSE",
    "BIELORRUSA",
    "BELGA",
    "BELICEÑA",
    "BOLIVIANA",
    "BRASILEÑO",
    "BRITÁNICA",
    "BRUNEANA",
    "BÚLGARA",
    "CABOVERDIANA",
    "CAMBOYANA",
    "CAMERUNESA",
    "CANADIENSE",
    "CHECA",
    "CHILENA",
    "CHINA",
    "CHIPRIOTA",
    "COLOMBIANA",
    "CONGOLEÑA",
    "COREANA",
    "COSTARRICENSE",
    "CROATA",
    "CUBANA",
    "DANESA",
    "DOMINICANA",
    "ECUATORIANA",
    "EGIPCIA",
    "ESCOCESA",
    "ESLOVACA",
    "ESLOVENO",
    "ESTADOUNIDENSE",
    "ESTONIA",
    "ETÍOPE",
    "FILIPINA",
    "FINLANDESA",
    "FRANCESA",
    "GHANESA",
    "GEORGIANO",
    "GRANADINA",
    "GRIEGA",
    "GUATEMALTECA",
    "GUYANESA",
    "HAITIANA",
    "HOLANDESA",
    "HÚNGARA",
    "INDONESIA",
    "HINDÚ",
    "INGLESA",
    "IRANÍ",
    "IRAQUÍ",
    "IRLANDESA",
    "ISLANDESA",
    "ISRAELITA",
    "ITALIANA",
    "JAMAIQUINA",
    "JAPONESA",
    "JORDANA",
    "KAZAKA",
    "KENIATA",
    "KIRIBATIANA",
    "KUWAITÍ",
    "LETONA",
    "LIBANESA",
    "LIBERIANA",
    "LIBIA",
    "LIECHTENSTEINIANA",
    "LITUANA",
    "LUXEMBURGUESA",
    "MACEDONIA",
    "MALASIA",
    "MALTÉS",
    "MARFILEÑA",
    "MARROQUÍ",
    "MEXICANA",
    "MOLDAVA",
    "NICARAGÜENSE",
    "NIGERIANA",
    "NORUEGA",
    "PAKISTANÍ",
    "PANAMEÑA",
    "PARAGUAYA",
    "PERUANA",
    "POLACA",
    "PORTUGUESA",
    "RUSA",
    "SUECA",
    "SUIZA",
    "TAILANDESA",
    "TURCA",
    "URUGUAYA",
    "UZBEKA",
    "VENEZOLANA",
    "VIETNAMITA",
    "AUSTRALIANA",
    "BAHAMEÑA",
    "BAREINÍ",
    "BENINÉS",
    "BOTSUANA",
    "ESPAÑOLA",
    "GALESA",
    "GROENLANDESA",
    "ECUATOGUINEANA",
    "HONDUREÑA",
    "NORIRLANDESA",
    "LESOTENSE",
    "MONAQUESA",
    "NEERLANDÉS",
    "NORCOREANA",
    "OMANÍ",
    "CATARÍ",
    "CENTROAFRICANA",
    "SERBIA",
    "SINGAPURENSE",
    "SALOMONENSE",
    "SIRILANQUESA",
    "SURINAMESA",
    "VANUATUENSE",
    "YEMENÍ",
    "MAURICIANA",
    "MOLDIVIANA",
    "MONGOLA",
    "BIRMANA",
    "NAMIBIA",
    "NEOZELANDESA",
    "NEPALESA",
    "PALESTINA",
    "RUANDESA",
    "RUMANA",
    "SALVADOREÑA",
    "SANMARINENSE",
    "SANCRISTOBALEÑO",
    "SANTALUCENSE",
    "SAUDITA",
    "SENEGALESA",
    "SIERRALEONÉS",
    "SIRIA",
    "SOMALÍ",
    "SUDAFRICANA",
    "TAIWANESA",
    "TIMORENSE",
    "TOGOLESA",
    "UCRANIANA",
    "TUNECINA",
    "SANVICENTINA",
    "YUGOSLAVA"
  ]